import SharedContextProvider from 'app/shared-components/SharedContext'
import Card from 'app/shared-components/Card'
import Fees from 'app/shared-components/Fees/FeesContainer'
import useLabel from 'app/hooks/useLabel'
import {
    FeesType,
} from 'app/enums/common.enums'

import {
    Fee,
} from 'app/Apps/Pricing/Pricing.types'
import {
    ContractCurrency,
} from 'app/enums/label.enums'

import useStyles from './LongTermLeaseFees.styles'

const LongTermLeaseFees = ({
    fees,
    currency,
}: Readonly<{
    fees: Fee[],
    currency: ContractCurrency
}>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    return (
        <Card
            title={l('LONG_TERM_LEASE_FEES')}
            titleClass={classes.cardTitle}
        >
            <SharedContextProvider
                value={{
                    feePricingName: FeesType.LongTermLease,
                }}
            >
                <Fees
                    value={fees}
                    currency={currency}
                    showSkyNetSpreadSheet
                    disabled
                />
            </SharedContextProvider>
        </Card>
    )
}

export default LongTermLeaseFees
